var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconGauge(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    width: "100%",
    height: "100%",
    overflow: "visible",
    style: {
      display: "block"
    },
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M3.33333 11.6667C3.17563 11.6672 3.02102 11.623 2.88745 11.5392C2.75389 11.4553 2.64686 11.3353 2.57879 11.1931C2.51072 11.0508 2.4844 10.8922 2.50291 10.7356C2.52142 10.5789 2.58398 10.4308 2.68333 10.3083L10.9333 1.80834C10.9952 1.73691 11.0795 1.68864 11.1725 1.67145C11.2654 1.65427 11.3614 1.66919 11.4448 1.71376C11.5281 1.75834 11.5938 1.82992 11.6311 1.91677C11.6684 2.00361 11.6751 2.10055 11.65 2.19168L10.05 7.20834C10.0028 7.33461 9.98697 7.47044 10.0038 7.60418C10.0207 7.73792 10.0697 7.86558 10.1467 7.9762C10.2238 8.08682 10.3265 8.1771 10.4461 8.23931C10.5656 8.30151 10.6985 8.33378 10.8333 8.33334H16.6667C16.8244 8.3328 16.979 8.37702 17.1125 8.46086C17.2461 8.5447 17.3531 8.66471 17.4212 8.80696C17.4893 8.94921 17.5156 9.10785 17.4971 9.26446C17.4786 9.42107 17.416 9.56921 17.3167 9.69168L9.06666 18.1917C9.00478 18.2631 8.92044 18.3114 8.82751 18.3286C8.73457 18.3457 8.63856 18.3308 8.55522 18.2863C8.47188 18.2417 8.40617 18.1701 8.36888 18.0833C8.33159 17.9964 8.32493 17.8995 8.34999 17.8083L9.94999 12.7917C9.99717 12.6654 10.013 12.5296 9.99617 12.3958C9.97932 12.2621 9.93028 12.1344 9.85325 12.0238C9.77623 11.9132 9.67352 11.8229 9.55393 11.7607C9.43435 11.6985 9.30146 11.6662 9.16666 11.6667H3.33333Z",
    stroke: "var(--stroke-0, #14B8A6)",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconGauge);
export default __webpack_public_path__ + "static/media/icon-gauge.31a835e092b712d9087efa7a2495796d.svg";
export { ForwardRef as ReactComponent };